import { useEffect, useRef } from 'react';

interface UseFocusOptions {
  trigger?: boolean;
}

export const useFocus = ({ trigger }: UseFocusOptions = {}) => {
  const elementRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) return;
    if (typeof trigger === 'undefined') {
      element.focus();
    } else {
      trigger ? element.focus() : element.blur();
    }
  }, [trigger]);

  return { ref: elementRef };
};
